import packageJson from '../package.json';

export const VERSION = packageJson.version;
export const version = packageJson.version;
export default VERSION;
